import { getPasskeyResetTitle } from "../notificationTitles.service";


export interface IPasskeyResetTitle {
    user: string;
    isPopOut?: boolean
}

const PasskeyResetTitle = ({user, isPopOut}: IPasskeyResetTitle ) => {
    const {className, activityInformation} = getPasskeyResetTitle({user, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}
        </span>
    );
};
export default PasskeyResetTitle;
